import styled from 'styled-components';

const ContentContainer = styled.div`
  background: ${props => props.theme.colors.backgroundPrimary};
  border: ${props => props.theme.colors.border};
  padding: ${({ noPadding }) => (noPadding ? '0px' : '15px')};
`;

export default ContentContainer;
